document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const formEmbed = document.querySelector('shopify-forms-embed#app-embed');
    if (formEmbed && formEmbed.shadowRoot) {
      obs.disconnect();
      
      const shadow = formEmbed.shadowRoot;
      
      // Move textarea placeholder to label above
      const textareas = shadow.querySelectorAll('textarea');
      textareas.forEach(textarea => {
        const placeholderText = textarea.placeholder;
        if (placeholderText && !textarea.dataset.labelCreated) {
          textarea.dataset.labelCreated = 'true';
          const label = document.createElement('div');
          label.textContent = placeholderText;
          label.style.cssText = 'display: block; font-size: 1.4em; font-weight: 700; line-height: 1.4; margin-bottom: 12px; color: #202020;';
          textarea.placeholder = '';
          textarea.closest('div').insertBefore(label, textarea);
        }
      });
      
      const style = document.createElement('style');
      style.textContent = `
        /* Question titles - bigger and bolder */
        legend,
        p[class*="label"],
        p[class*="textBody"],
        [class*="selectToggleText"] {
          font-size: 1.4em !important;
          font-weight: 700 !important;
          line-height: 1.4 !important;
          margin-bottom: 12px !important;
          color: #202020 !important;
        }
        
        /* Answer text - 16px */
        label[class*="checkboxField"],
        span[class*="textBody"] {
          font-size: 16px !important;
          font-weight: 400 !important;
        }
        
        /* Input fields (Name, Email) - 16px */
        input,
        input::placeholder,
        textarea {
          font-size: 16px !important;
        }
        
        /* Dropdown select styling */
        select,
        [class*="selectContainer"] {
          font-size: 16px !important;
        }
      `;
      shadow.prepend(style);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});